module.exports = __webpack_public_path__ + "static/media/r3s3.d39d4b83.jpg";